<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AppLayout from '@/layouts/AppLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'

const route = useRoute()
const router = useRouter()

/**
 * 首次导航完成前（懒加载路由组件下载中）route 为 START_LOCATION、meta 为空，
 * 直接按默认 app 布局渲染会让嵌入聊天页/登录页先闪现平台框架（侧边栏+顶栏）再切换；
 * 此时按目标地址预判布局，避免首屏闪现错误布局。
 */
const layout = computed(() => {
  if (route.matched.length) return (route.meta.layout as string) ?? 'app'
  const target = router.resolve(window.location.pathname + window.location.search)
  return (target.meta.layout as string) ?? 'app'
})

onMounted(async () => {
  const auth = useAuthStore()
  if (auth.isAuthenticated) {
    try {
      await auth.fetchMe()
    } catch {
      // 令牌无效 —— interceptor 已处理跳转
    }
  }
})
</script>

<template>
  <AuthLayout v-if="layout === 'auth'">
    <router-view />
  </AuthLayout>
  <AppLayout v-else>
    <router-view />
  </AppLayout>
</template>
